module.exports = __webpack_public_path__ + "img/4.cff81d00.jpeg";